var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-chip',{staticClass:"chip-tight",attrs:{"small":"","color":_vm.tone.color,"text-color":_vm.tone.text}},[_vm._v(_vm._s(_vm.status))])}
var staticRenderFns = []

export { render, staticRenderFns }